import React, { createContext, useContext, useCallback, useMemo } from 'react';

import { useStateWithSessionStorage } from '../hooks/useStateWithSessionStorage';

const InvoiceContext = createContext({});

const defaultValues = {
  invoiceNumber: null,
  invoiceId: null,
  invoicePreview: null,
  subscriptionId: null,
};
function InvoiceProvider({ children }) {
  const [invoiceNumber, setInvoiceNumber] = useStateWithSessionStorage(
    'invoiceNumber',
    defaultValues.invoiceNumber
  );
  const [invoiceId, setInvoiceId] = useStateWithSessionStorage(
    'invoiceId',
    defaultValues.invoiceId
  );
  const [invoicePreview, setInvoicePreview] = useStateWithSessionStorage(
    'invoicePreview',
    defaultValues.invoicePreview
  );
  const [subscriptionId, setSubscriptionId] = useStateWithSessionStorage(
    'subscriptionId',
    defaultValues.subscriptionId
  );

  const resetInvoiceNumber = useCallback(
    () => setInvoiceNumber(defaultValues.invoiceNumber),
    [setInvoiceNumber]
  );

  const resetInvoiceId = useCallback(
    () => setInvoiceId(defaultValues.invoiceId),
    [setInvoiceId]
  );

  const resetInvoicePreview = useCallback(
    () => setInvoicePreview(defaultValues.invoicePreview),
    [setInvoicePreview]
  );

  const resetSubscriptionId = useCallback(
    () => setSubscriptionId(defaultValues.subscriptionId),
    [setSubscriptionId]
  );

  const contextValue = useMemo(
    () => ({
      invoiceNumber,
      setInvoiceNumber,
      resetInvoiceNumber,
      invoiceId,
      setInvoiceId,
      resetInvoiceId,
      invoicePreview,
      setInvoicePreview,
      resetInvoicePreview,
      subscriptionId,
      setSubscriptionId,
      resetSubscriptionId,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [invoiceNumber, invoiceId, invoicePreview, subscriptionId]
  );

  return (
    <InvoiceContext.Provider value={contextValue}>
      {children}
    </InvoiceContext.Provider>
  );
}

function useInvoice() {
  const context = useContext(InvoiceContext);
  if (context === undefined) {
    throw new Error('usePlan must be used within a InvoiceContext');
  }

  return context;
}

export { InvoiceProvider, useInvoice };
